import classNames from "classnames";
import ScanResultAlert from "~/features/scanDmc/components/ScanResultAlert/ScanResultAlert";
import ContactFormOverlay from "~/features/scanDmc/components/ContactFormOverlay/ContactFormOverlay";
import { appendOverlayParamToUrl, getScanResultFromUrl } from "~/features/scanDmc/utils/scanDmcUtils";
import { useBooleanState } from "~/common/hooks/useBooleanState";
import { useEffect, useState } from "react";
import { ScanResultType } from "~/features/scanDmc/types/ScanDMC";
import { LinkButton } from "~/common/components/Link";
import { fetchScanDMCOriginCheck } from "~/features/scanDmc/api/fetchScanDMCOriginCheck";
import { CircularProgress, styled } from "~/common/mui";
import { useTranslation } from "react-i18next";
import AutorenewIcon from "@mui/icons-material/Autorenew";

const AlertRoot = styled("div")({
  position: "relative",
  display: "grid",
  alignSelf: "stretch",
  "& > *": {
    gridRow: 1,
    gridColumn: 1,
  },
});

interface Props {
  className?: string;
  productCode: string;
}

export const PdpScanResultSection = (props: Props) => {
  const [scanResult, setScanResult] = useState(() => getScanResultFromUrl(props.productCode));
  const [redoLoading, setRedoLoading] = useState(false);
  const { t } = useTranslation();

  const overlayParamValue = new URLSearchParams(window.location.href).get("overlayOpen") === "true";
  const { val: overlayOpen, setTrue: openOverlay, setFalse: closeOverlay } = useBooleanState(overlayParamValue);

  if (!scanResult) {
    return null;
  }

  const showRedoScan = scanResult.type === ScanResultType.AlreadyScanned;

  const redoScan = async () => {
    setRedoLoading(true);
    const newScanResult = await fetchScanDMCOriginCheck(scanResult.dmcCode, true);
    setRedoLoading(false);
    setScanResult(newScanResult);
  };

  useEffect(() => {
    appendOverlayParamToUrl(window.location.href, overlayOpen);
  }, [overlayOpen]);

  return (
    <div className={classNames(props.className)}>
      <AlertRoot>
        <ScanResultAlert
          openOverlay={openOverlay}
          scanResult={scanResult.type}
          className={redoLoading ? "v-hidden" : undefined}
        />
        {redoLoading && <CircularProgress size={50} sx={{ justifySelf: "center", alignSelf: "center" }} />}
      </AlertRoot>

      {showRedoScan && (
        <LinkButton onClick={redoScan} disabled={redoLoading} iconBefore={<AutorenewIcon  />}>
          {t("feature.scandmc.revalidateBtn")}
        </LinkButton>
      )}

      {overlayOpen && (
        <ContactFormOverlay onClose={closeOverlay} scanResult={scanResult.type} dmcCode={scanResult.dmcCode} />
      )}
    </div>
  );
};
